import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    corporationId: string;
    loanRequestId: string;
};

export const schemaLoanRequestResolver_IsUnassignedOfCorporation = z.boolean();

export type SchemaLoanRequestResolver_IsUnassignedOfCorporation = z.infer<
    typeof schemaLoanRequestResolver_IsUnassignedOfCorporation
>;

export type LoanRequestResolver_IsUnassignedOfCorporation = Resolver<
    Arguments,
    SchemaLoanRequestResolver_IsUnassignedOfCorporation
>;
